import { render } from "./WalletApp.vue?vue&type=template&id=918961c6&scoped=true"
import script from "./WalletApp.vue?vue&type=script&lang=js"
export * from "./WalletApp.vue?vue&type=script&lang=js"

import "./WalletApp.vue?vue&type=style&index=0&id=918961c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-918961c6"]])

export default __exports__